





















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import DragIcon from '@/shared/components/DragIcon.vue';
import { FlowSelectorItemViewModel } from '../../models/flowSelectorItemViewModel';
import appInsights from '@/shared/services/appInsights';
import { Getter } from 'vuex-class';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import TitledSection from '@/shared/components/TitledSection.vue';
import Icon from '@/shared/icons/Icon.vue';

@Component({ components: { TitledSection, Draggable, DragIcon, Icon } })
export default class FlowSelector extends Vue {
	@Prop({required: true}) public value!: FlowSelectorItemViewModel[];
	@Prop({required: true}) public title!: string;
	@Prop({required: true}) public subtitle!: string;
	@Prop({required: true}) public icon!: 'FlowIcon' | 'AnswerIcon';
	@Prop({default: ''}) public tooltip!: string;
	@Prop({default: true}) public reorderable!: boolean;
	@Getter public currentWorkspace!: WorkspaceViewModel;

	public flows: FlowSelectorItemViewModel[] = [];

	@Watch('value', { immediate: true })
	public handleValueChange(value: FlowSelectorItemViewModel[]) {
		this.flows = value;
	}

	public handleFlowSelectedChange() {
		appInsights.trackEvent({ name: 'Bot Preview: Flow selected changed' }, { workspaceId: this.currentWorkspace.id});
		this.setPriorities();
		this.$emit('input', this.flows);
	}

	public updatePriorities() {
		appInsights.trackEvent({ name: 'Bot Preview: Flow priorities changed' }, { workspaceId: this.currentWorkspace.id});
		this.setPriorities();
		this.$emit('input', this.flows);
	}

	public setPriorities() {
		let selectedFlowCount = this.flows.filter(x => x.isSelected).length;
		this.flows.forEach(flow => {
			flow.priority = flow.isSelected ? selectedFlowCount-- : 0;
		});
	}
}
